import { computed } from 'vue';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';
import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';
import { useInputStore } from '@/features/Sparten';
import { getCurrentSpartenConfig } from '@/utils/getCurrentSpartenConfig/getCurrentSpartenConfig';

export const hasRelationshipWithAPartner = computed(() => {
  const { hasPartner } = getCurrentSpartenConfig();

  if (hasPartner !== undefined) {
    return hasPartner();
  }

  return getSimpleChoiceMeta(
    SIMPLE_CHOICE.TARIFART,
    SIMPLE_CHOICE_META.TARIFART_HAS_PARTNER,
  ).includes(useInputStore().tarifart);
});
